import React from 'react'
import { RichText } from '../../helpers/react'
import { Card, Icon } from '../../../atoms'
import Button from '../../../atoms/button'
import classNames from 'classnames'
import ImgixImage from '../../helpers/imgix-image'
import Form from '../../form'
import { useEntity } from '../../helpers/selectors'

const CallOutCard = (props) => {
  const { content, jsonBody, brand, sys, rawName, variant, form } = props
  const formData = useEntity(form)
  const isCallOutCardWithHighlight = Boolean(jsonBody.highlightText)

  return (
    <Card
      className={classNames('CallOutCard', {
        HasHighlight: isCallOutCardWithHighlight,
        HasBadge: jsonBody.isIconBadge,
      })}
      style={{
        background: jsonBody.background,
        backgroundColor: jsonBody.backgroundColor,
        border: jsonBody.border,
        color: jsonBody.textColor,
      }}
    >
      {(jsonBody.icon || jsonBody.iconText) &&
        (jsonBody.isIconBadge ? (
          <div className='CallOutCard-icon-wrapper-badge'>
            <Icon glyph={jsonBody.icon} brand={brand} ariaLabel={jsonBody.icon} size={30} />
            {jsonBody.iconText && (
              <span style={{ color: jsonBody.ctaColor }}>{jsonBody.iconText}</span>
            )}
          </div>
        ) : (
          <div
            className='CallOutCard-top-cta-wrapper'
            style={{
              backgroundColor: jsonBody.ctaBackgroundColor,
              color: jsonBody.ctaColor,
              borderColor: jsonBody.ctaBorderColor,
              border: jsonBody.ctaBorderColor ? '1px solid' : 'none',
            }}
          >
            <div className='CallOutCard-top-cta-wrapper-inner'>
              {jsonBody.icon && (
                <div className='CallOutCard-icon-wrapper'>
                  <Icon glyph={jsonBody.icon} brand={brand} ariaLabel={jsonBody.icon} size={24} />
                </div>
              )}
              {jsonBody.iconText && (
                <span style={{ color: jsonBody.ctaColor }}>{jsonBody.iconText}</span>
              )}
            </div>
          </div>
        ))}

      {jsonBody.heading && jsonBody.subHeading && (
        <>
          <h3
            className='CallOutCard-heading'
            style={{
              color: `${jsonBody.textColor} !important`,
            }}
          >
            {jsonBody.heading}
          </h3>
          <p className='CallOutCard-subHeading'>{jsonBody.subHeading}</p>
        </>
      )}

      {isCallOutCardWithHighlight && (
        <div className='HasHighlight-highlight'>
          {jsonBody.highlightIcon && (
            <div className='HasHighlight-highlight-icon-wrapper'>
              <Icon
                glyph={jsonBody.highlightIcon}
                brand={brand}
                ariaLabel={jsonBody.highlightIcon}
                size={24}
              />
            </div>
          )}
          <p className='HasHighlight-highlight-text'>{jsonBody.highlightText}</p>
        </div>
      )}

      <div className='CallOutCard-content'>
        <RichText content={content.content} />
      </div>

      <div className='CallOutCard-footer'>
        <div className='CallOutCard-footer-cta-wrapper'>
          {jsonBody.button && (
            <Button
              variant={jsonBody.button.variant}
              size='md'
              href={jsonBody.button.href}
              dataClickTracking={{
                component_category: 'platinum-component',
                component_id: sys?.id,
                component_name: 'product-call-out',
                contentful_name: rawName,
                contentful_variant: variant,
              }}
              openInNewTab
            >
              {jsonBody.button.text}
            </Button>
          )}
          {form && <Form {...formData} />}
          {jsonBody.link && (
            <div className='CallOutCard-footer-link'>
              <a
                href={jsonBody.link.href}
                style={{
                  color: jsonBody.textColor,
                }}
              >
                {jsonBody.link.text}
              </a>
            </div>
          )}
        </div>
        {jsonBody.image && (
          <div className='CallOutCard-footer-logo-wrapper'>
            <ImgixImage src={jsonBody.image.src} alt={jsonBody.image.alt} width={260} />
          </div>
        )}
      </div>
    </Card>
  )
}

export default CallOutCard
